import React from 'react'
import Select from 'react-select'
import FormInput from './FormInput'
import { moneyize } from '../TextPresenters/moneyize'
import { useSelector } from 'react-redux'


export function SelectPaymentOptions(props){
  const organization = useSelector(state=>state.organization)
  const { payment_sources } = useSelector(state=>state.paymentSources)
  const { balance } = useSelector(state=>state.account)
  const { showNewPaymentMethodButton = true, desc, label, labelClassName, handlePaymentSourceChange, handleNewPaymentOptionClick, 
          value, hasInvoiceOption, hasCashOption, hasExternalOptions, hasOtherCardOption, hasCheckOption, hasOtherOption, hasBalanceOption = true,
          disabled } = props

  function generateAddBankAccountMessage(){
    return({
      id: 'n/a',
      kind: 'bank_account_message'
    })
  }

  function generateOption(option){
    return({
      id: option,
      kind: option
    })
  }

  var allPaymentSources = [...payment_sources.filter(source=>source.is_verified)]
  hasBalanceOption && allPaymentSources.push(generateOption("balance"))
  hasCashOption && allPaymentSources.push(generateOption("cash"))
  hasInvoiceOption && allPaymentSources.push(generateOption("invoice"))
  hasCheckOption && allPaymentSources.push(generateOption("check"))
  hasExternalOptions && allPaymentSources.push(...(['cashapp', 'venmo', 'stripe', 'paypal', 'money_order', 'zelle', 'vanco'].map(generateOption)))
  hasOtherOption && allPaymentSources.push(generateOption("other"))
  organization.payment_processor && hasOtherCardOption && allPaymentSources.push(generateOption("other_card"))
  organization.payment_processor && organization["ach_enabled?"] && allPaymentSources.push(generateAddBankAccountMessage())
  function formatOption(option){
    switch(option.kind){
      case "bank_account":
        return {
          label: `${option.name}`,
          value: option.id
        }
      case "card":
        return {
            label: option.name,
            value: option.id
        }
      case "cash":
        return {
            label: `Cash`,
            value: option.kind
        }
      case "check":
        return {
          label: `Check`,
          value: option.kind
        }
      case "other":
        return {
          label: `Other`,
          value: option.kind
        }
      case "cashapp":
        return {
          label: `Cashapp`,
          value: option.kind
        }
      case "venmo":
        return {
          label: `Venmo`,
          value: option.kind
        }
      case "stripe":
        return {
          label: `Stripe`,
          value: option.kind
        }
      case "paypal":
        return {
          label: `PayPal`,
          value: option.kind
        }
      case "money_order":
        return {
          label: `Money Order`,
          value: option.kind
        }
      case "zelle":
        return {
          label: `Zelle`,
          value: option.kind
        }
      case "vanco":
        return {
          label: `Vanco`,
          value: option.kind
        }
      case "balance":
        return {
          label: `Pay With Available Funds (${moneyize(balance)})`,
          value: option.kind
        }
      case "invoice":
        return {
          label: `Invoice`,
          value: option.kind
        }
      case "other_card":
        return {
          label: `Add New Card...`,
          value: option.kind
        }
      case "bank_account_message":
        return {
          label: 'Add New Bank Account? Go to Payment Info> New Payment Source> Bank Account',
          disabled: 'yes',
          value: 'howdy',
        }
    }
  }

  function formatPaymentMethodOptions(){
    var options = []
    allPaymentSources.map(payment_source=>{
      return options.push(formatOption(payment_source))
    })
    return options
  }

  function onChange(e){
    handlePaymentSourceChange(
      allPaymentSources.filter(payment_source=> payment_source.id === e.value)[0]
    )
  }

  const paymentMethodOptions = formatPaymentMethodOptions()
  return(
    <div>
      <FormInput
        label={ label || "Payment Source" }
        labelClassName={labelClassName}
        type="select"
        className=""
        disabled={disabled}
        desc={desc}
        value={value ? formatOption(value) : null}
        options={paymentMethodOptions}
        handleChange={(e)=>onChange(e)}/>
      { showNewPaymentMethodButton && <button className="btn btn-sm btn-white p-0 text-info mb-3 mt-1" onClick={()=>handleNewPaymentOptionClick()}>Add New Payment Source</button>}
    </div>
  )
}
export default SelectPaymentOptions
